import { Box, Typography } from "@mui/material";
import {
  EmptyMessageWrapper,
  ConsentListStyle,
} from "../../../../../EConsent/Builder/block.style";

const ConsentFormEmpty = () => {
  return (
    <Box sx={ConsentListStyle}>
      <EmptyMessageWrapper>
        <Typography variant="h3" color="grey">
          No consent block found
        </Typography>
      </EmptyMessageWrapper>
    </Box>
  );
};

export default ConsentFormEmpty;
